var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"imagediv"},[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":require('@/assets/iphone/xieyitop.png')}}),_c('div',{staticClass:"title"},[_vm._v("用户协议")])],1),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.xieyi)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }